import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'salesFunnelViews'

export type SalesFunnelViewFilters = {
  directors: Array<{ _id: string; display?: string }>
  clients: Array<{ _id: string; display?: string }>
  offices: Array<{ _id: string; display?: string }>
}

export type SalesFunnelViewPayload = {
  name: string
  viewType?: string
  sortBy?: string
  sortOrder?: -1 | 1
  search?: string
  filters?: SalesFunnelViewFilters
  visibleColumns?: string[]
}

export type SalesFunnelView = SalesFunnelViewPayload & {
  _id: string
  _firmId?: string
  authorId?: string
  _created?: string
  _updated?: string
  isDeleted?: boolean
}

const list = (axios: IFactoryFunctionRequest<any, any>) => (query: Record<string, unknown> = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    query,
  })
}

const create = (axios: IFactoryFunctionRequest<any, any>) => (data: SalesFunnelViewPayload) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<any, any>) => (id: string, data: Partial<SalesFunnelViewPayload>) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    data,
  })
}

const softDelete = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  list: list(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  softDelete: softDelete(useAxios(axios)),
})
